import { CreateSSOProvider, SSOContext } from '@ordr-as/authentication-library';
import { useContext, useMemo } from 'react';
import config from '../config';

const { provider } = CreateSSOProvider({
  callback_url: window.location.origin,
  environment: config.env === 'prod' ? 'prod' : 'qa',
  app_name: 'bar-waiter',
  version: 'v3',
});

const useAuth = () => {
  const authContext = useContext(SSOContext);

  if (!authContext) {
    throw new Error('useAuth must be used within an SSOProvider');
  }

  return authContext;
};

const useUser = () => {
  const authContext = useContext(SSOContext);

  return useMemo(() => {
    if (!authContext) {
      return undefined;
    }
    return {
      email: authContext?.decodedAccessToken.sub,
      role: authContext?.decodedAccessToken.isAdmin ? 'ADMIN' : 'CUSTOMER',
    };
  }, [authContext]);
};

export default provider;
export { useAuth, useUser };
